import { Navaids } from '../menu/view-menu/layersList';
import { Filter } from '../popup/configure-flight-inpection-format/configure-flight-inpection-format.component';
import { ShapeType } from './EnumTypes';
import { FilterModel } from './filter';
import {filter} from "lodash";
import {GritFilter} from "./grit/grit.filter";

export class UserSettingsDTO{
  id:number;
  usersettingsstr: string;
}
export class UserSettings{
  cumulativeCoverageColors: LayerColor[];
  navaidSettings: NavaidSettings = new NavaidSettings();
  coordinatePointSettings: CoordinatePointSettings = new CoordinatePointSettings();
  airspaceSettings: AirSpaceSettings = new AirSpaceSettings();
  procedureSettings: ProcedureSettings = new ProcedureSettings();
  trajectorySettings: TrajectorySettings = new TrajectorySettings();
  saamTrafficLayerSettings: SaamTrafficDensitySettings = new SaamTrafficDensitySettings();

  //#region Grit
  devicesSettings = new DevicesSettings();
  receiversSettings =  new ReceiversSettings();
  interferenceTestSettings = new InterferenceTestSettings();
  radarsSettings = new RadarsSettings();
  //endregion

  routeSegmentVisibilities: LayerVisibility[] = [];
  annotationsVisibility: LayerVisibility[] = [];
  flightInspectionsVisibility : LayerVisibility[] = [];
  processingToolVisibility : LayerVisibility[] = [];
  colorSettings: ColorSettings = new ColorSettings();

  epsg: string= "EPSG:3857";
  visibleStaticLayerIDs :number[] = [];
  // layerVisibilities: any[] = [];
  calculationsVisibility: any[] = [];
  coordinatePointFilters: FilterModel[] = [];
  navaidFilters: FilterModel[] = [];
  userLayers: UserLayer[] = [];
  staticGeoJsonLayers: UserLayer[] = [];

  calculationsTransparency: any[] = [];
}
export class ColorSettings{
  navaidColors : NavaidColors = new NavaidColors();
  coordinatePointColors = new CoordinatePointColors();
  airspaceColor: string = '#ff0000';

}
export class ColotSettings{
  Air_Space_Boundary = '#ff0000';
}
export class FlightInspectionSettings{

}
export class SaamTrafficDensitySettings{
  saamLayerVisibility: SaamTrafficVisibility = new SaamTrafficVisibility();
  saamLayerSettings: FilterModel[] = [];
}
export class SaamTrafficVisibility{
  SAAM_Traffic_Layer: boolean = true;
}
export class TrajectorySettings{
  trajectoryVisibility : TrajectoryVisibility = new TrajectoryVisibility();
  trajectoryFilters : FilterModel[] = [];
}
export class ProcedureSettings{
  procedureVisibility : ProcedureVisibility = new ProcedureVisibility();
  procedureFilters : FilterModel[] = [];
}
export class LayerVisibility{
  id : string;
  visible : boolean;
}
export class TrajectoryVisibility{
  Trajectory : boolean = true;
}

export class ProcedureVisibility {
  sid:boolean = true;
  star : boolean = true;
  enroute : boolean = true;
  assessment : boolean = true;
  assessmentoffset : boolean = true;
}
export class AirSpaceSettings{
  Air_Space_Boundary : boolean = true;
  airspaceFilters : FilterModel[] = [];
}
export class NavaidSettings{
  navaidVisibility : NavaidVisibility = new NavaidVisibility();
}
export class NavaidVisibility{
  all = true;
  dme = true;
  vor_dme = true;
  tacan = true;
  vortac = true;
  dme_ils = true;
  ndb = true;
  vor = true;
}
export class NavaidColors{
  all  = [{color:''}];
  dme = [{color:''},{color:''}];
  vor_dme = [{color:''},{color:''}];
  tacan = [{color:''},{color:''}];
  vortac = [{color:''},{color:''}];
  dme_ils = [{color:''},{color:''}];
  ndb = [{color:''},{color:''}];
  vor = [{color:''},{color:''}];
}
export class CoordinatePointSettings{
  coordinatePointVisibility = new CoordinatePointVisibility();
  coordinatePointFilters: FilterModel[] = [];
}
export class CoordinatePointVisibility{
  all = false;
  waypoint = false;
  arp_civil = false;
  arp_mixed = false;
  rwy_thr = false;
  airspace_vertex = false;
  fix_point = false;
  arp_militar = false;
}
export class CoordinatePointColors{
  all = [{color:''}];
  waypoint = [{color:''},{color:''}];
  arp_civil = [{color:''},{color:''}];
  arp_mixed = [{color:''},{color:''}];
  rwy_thr = [{color:''},{color:''}];
  airspace_vertex = [{color:''},{color:''}];
  fix_point = [{color:''},{color:''}];
  arp_militar = [{color:''},{color:''}];
}
export class AirSpaceBoundaryColors{
  airspace = '#ff0000';
}
export class LayerColor{
  color:string;
  id: number;
  constructor(color:string, id:number){
    this.color = color;
    this.id = id;
  }
}
export class ColorOfType{
  public type: string;
  public subtype: string;
  public status: string;
  public color: string;

  constructor(type:string,subtype:string,status:string, color:string){
    this.type = type;
    this.subtype = subtype;
    this.status = status;
    this.color = color;
  }
}
export class UserLayer{
  public id: number;
  public type: string;
  public data: string;
  public name: string;
  public visible:boolean = true;

  public fillColor:string;
  public strokeColor: string;
  public lineWidth: number;
  public shape: string = ShapeType.Circle;
  public radius: number = 3;
  public labels: string[];
  public propertyDisplayed: string;
  public userLayerColorActive = false;
  public padding: number[] = [0,0,0,0];
  public lineOpacity: number;
  public fillOpacity: number;
  public lineChecked: boolean = true;
  public fillChecked:boolean = true;
  public labelChecked: boolean = false;
  public markerChecked: boolean = false;
  constructor(id: number, type: string, data: string, name: string, labels:string[]) {
    this.id = id;
    this.type = type;
    this.data = data;
    this.name = name;
    this.labels = labels;
  }
}

//#region Grit
export class DevicesSettings {
  visibility = {
    all : true,
    jammer: true,
    spoofer: true,
  }
}

export class ReceiversSettings {
  visibility = {
    all : true,
    receiver: true,
  }
}

export class RadarsSettings {
  visibility = {
    radar : true,
    user_radar: true,
  };

  filters : GritFilter[] = [];
}

export class InterferenceTestSettings {
  visibility = {
    all : true,
    current: true,
    approval: true,
    approved: true,
    executing: true,
  };

   filters : GritFilter[] = []
}



//endregion
